var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ListSearchable", {
    ref: "list",
    staticClass: "d-flex flex-column",
    staticStyle: { height: "300px" },
    attrs: {
      "base-url": _vm.url,
      input: { placeholder: "Search", clearable: true, class: ["mb-2"] },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ item, isCurrent, select }) {
          return [
            _c(
              "div",
              {
                staticClass: "item-list__item cursor-pointer user-select-none",
                class: { "item-list__item_current": isCurrent },
                on: {
                  click: function ($event) {
                    return _vm.onClick(select, item)
                  },
                },
              },
              [
                _vm.hasTags(item)
                  ? _c(
                      "div",
                      { staticClass: "d-flex flex-wrap gap-1 mb-1" },
                      _vm._l(
                        _vm.itemTags(item),
                        function ({ title, is_system }) {
                          return _c(
                            "div",
                            {
                              staticClass: "badge text-uppercase",
                              class: [
                                is_system ? "badge-info" : "badge-secondary",
                              ],
                            },
                            [_vm._v(_vm._s(title))]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "message-content line-height-15" }, [
                  _vm._v(_vm._s(_vm.getContent(item))),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }